import { render, staticRenderFns } from "./sso-credentials.vue?vue&type=template&id=10836f1a&scoped=true&"
import script from "./sso-credentials.ts?vue&type=script&lang=ts&"
export * from "./sso-credentials.ts?vue&type=script&lang=ts&"
import style0 from "./sso-credentials.scss?vue&type=style&index=0&id=10836f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10836f1a",
  null
  
)

export default component.exports